namespace Matrix.Data {
    export interface SecurityMatchRulesetRow {
        RulesetCode?: string;
        Description?: string;
        RowId?: number;
        Version?: number;
        CreatedBy?: string;
        CreatedWhen?: string;
        UpdatedBy?: string;
        UpdatedWhen?: string;
        Priority?: number;
        Enabled?: boolean;
        AutoReview?: boolean;
        SecurityMatchRuleList?: SecurityMatchRulesetRuleRow[];
    }

    export namespace SecurityMatchRulesetRow {
        export const idProperty = 'RulesetCode';
        export const nameProperty = 'RulesetCode';
        export const localTextPrefix = 'Data.SecurityMatchRuleSet';
        export const lookupKey = 'Data.SecurityMatchRuleset';

        export function getLookup(): Q.Lookup<SecurityMatchRulesetRow> {
            return Q.getLookup<SecurityMatchRulesetRow>('Data.SecurityMatchRuleset');
        }
        export const deletePermission = 'DataAdmin:SecurityMatchRuleset';
        export const insertPermission = 'DataAdmin:SecurityMatchRuleset';
        export const readPermission = 'Read:SecurityMatchRuleset';
        export const updatePermission = 'DataAdmin:SecurityMatchRuleset';

        export declare const enum Fields {
            RulesetCode = "RulesetCode",
            Description = "Description",
            RowId = "RowId",
            Version = "Version",
            CreatedBy = "CreatedBy",
            CreatedWhen = "CreatedWhen",
            UpdatedBy = "UpdatedBy",
            UpdatedWhen = "UpdatedWhen",
            Priority = "Priority",
            Enabled = "Enabled",
            AutoReview = "AutoReview",
            SecurityMatchRuleList = "SecurityMatchRuleList"
        }
    }
}
